var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9053 3.625C14.985 3.62622 16.0237 4.02862 16.8203 4.75L16.9766 4.89844C17.7401 5.66195 18.1897 6.6806 18.2441 7.75391L18.25 7.96973C18.2495 10.4698 16.3787 12.8142 14.3232 14.6143C12.8011 15.9473 11.2524 16.9163 10.5078 17.3525L10.0625 17.6045L10.0596 17.6064C10.0414 17.6162 10.0207 17.6211 10 17.6211C9.98979 17.6211 9.97956 17.6206 9.96973 17.6182L9.94043 17.6064L9.9375 17.6055L9.49219 17.3525C8.74763 16.9163 7.1989 15.9473 5.67676 14.6143C3.62129 12.8142 1.75049 10.4698 1.75 7.96973C1.75122 6.88995 2.15362 5.85129 2.875 5.05469L3.02344 4.89844C3.83774 4.08413 4.94217 3.62645 6.09375 3.625C7.56091 3.625 8.82107 4.25378 9.60059 5.29199L10 5.82422L10.3994 5.29199C11.1788 4.25402 12.4385 3.62528 13.9053 3.625Z",
    stroke: "#D52035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHeart);
export default __webpack_public_path__ + "static/media/empty-heart.90603fe865798fbbd9316ddd15c82f62.svg";
export { ForwardRef as ReactComponent };